import React, { useState, useEffect }  from "react";
import { connect } from "react-redux";
import { useParams } from 'react-router-dom';
import { Modal, Input } from 'antd';
import Button from "components/button";
import PayslipDetails from "./components/PayslipDetails";
import { getPayslipDetails } from "../../../redux/payrun/payrunState";
import { Alert } from 'antd';

const MyPayslip = ({getMyPayslip, errorMsg}) => {
	const { empCode, payrollId, hash } = useParams();
	const [ open, setOpen ] = useState(false);	
	const [ securityCode, setSecurityCode ] = useState();
	
	const handleChange = (event) => {
	    const value = event.target.value;
	    setSecurityCode(value);
	}
  
	const submitSecurityCode = () => {
		getMyPayslip({payrollId, empCode, hash, securityCode});
	}
	
	const handleKeyPress = (event) => {
    	if (event.key === 'Enter') {
			setOpen(false);
			submitSecurityCode();      		
    	}
  	};
	
	useEffect(() => {
	    errorMsg && setOpen(true);
    }, [errorMsg]);
	
	return (
    	<div>	    
	    	<PayslipDetails />
	      	<Modal
                open={open}
                closeIcon={false}
                centered
                title="Security Code"
                okText="Submit"
                cancelText=""
                footer={(_) => (
                    <>                        
                        <Button className="btn-primary" 
                            onClick={(e) => {setOpen(false); submitSecurityCode();}}
                        >
                            Submit
                        </Button>
                    </>
                )}
            >
	            <Input className="py-2" id="security_code" onChange={handleChange} onKeyPress={handleKeyPress}/>
	            {errorMsg && <Alert className="mb-5" message={errorMsg} type="error" showIcon />}
            </Modal>
	    </div>
    );
};

const mapStateToProps = (state) => ({
	errorMsg: state.payrun.payslipDetails?.error,
});

const mapDispatchToProps = (dispatch) => ({
	getMyPayslip: (parameters) => dispatch(getPayslipDetails(parameters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MyPayslip);